import React, { useEffect, useState } from "react";
import "./moreDropdown.css";
import { useNavigate } from "react-router-dom";
import giftCardIcon from "../../../../assets/dropdowIcon/card_giftcard.svg";
import kotak from "../../../../assets/dropdowIcon/koktacredit.svg";
import advertiseIcon from "../../../../assets/dropdowIcon/newspaper_black.svg";
import Honk from "../../../../assets/ads-screen/honk-icon.svg";
import pristineIcon from "../../../../assets/dropdowIcon/auto_awesome.svg";
import pvrcareIcon from "../../../../assets/dropdowIcon/care.svg";
import merchandiseIcon from "../../../../assets/dropdowIcon/local_mall_black.svg";
import movieOnDemand from "../../../../assets/dropdowIcon/theaters_black.svg";
import custoArrowB from "../../../../assets/cities/black-cities.svg";
import menubar from "../../../../assets/nav-icon/menubar.svg";
import OdrBlack from "../../../../assets/nav-icon/odr-black.svg";
import odrWhite from "../../../../assets/nav-icon/odr-white.svg";
import filmFestival from "../../../../assets/nav-icon/Film-festival-1.png";
import promoteEarn from "../../../../assets/nav-icon/Promote.svg";
import Screenit_icon from "../../../../assets/nav-icon/screenit_logo.png";
import { getSplashData } from "src/services/OtherServices";
import { InputText } from "primereact/inputtext";
import { ProceedButton } from "src/styled-components/generalTags";
import * as appConstants from "../../../../constants/index";
import axios from "axios";
import cinemaHouse from "../../../../assets/comingsoon/Cinema House 1.gif";
import OtpInput from "react-otp-input";
// import ConfirmMessageDialog from "src/global-functions/ConfirmMessageDialog";
import ConfirmMessageDialog from "../../../../global-functions/ConfirmMessageDialog";

const LoginPopup = ({ isOpen, onClose, theme, spalshData }) => {
  const navigate = useNavigate();
  const [userNumber, setUserNumber] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [errors, setErrors] = useState({});
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  if (!isOpen) return null;

  // 🔐 Generate hash (same as Swift)
  async function generateHashText(mobile, platform) {
    const secretKey = "tdy*gdr?diu(grui^j9utyf";
    const timestamp = Date.now();
    const hashText = `|${mobile}|${timestamp}|${secretKey}|${mobile.substring(
      0,
      6
    )}|${platform}|`;

    const encoder = new TextEncoder();
    const data = encoder.encode(hashText);
    const hashBuffer = await crypto.subtle.digest("SHA-512", data);
    const hashArray = new Uint8Array(hashBuffer);
    const hashBase64 = btoa(String.fromCharCode(...hashArray));

    return { hash: hashBase64, timestamp };
  }

  // 📲 Request OTP
  const handleLogin = async () => {
    let newErrors = {};

    if (!userNumber) {
      newErrors.userNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(userNumber)) {
      newErrors.userNumber = "Enter a valid 10-digit phone number";
    }

    if (!userCompany) {
      newErrors.userCompany = "Organisation name is required";
    }

    if (!userEmail) {
      newErrors.userEmail = "Email is required";
    }

    if (!userLocation) {
      newErrors.userLocation = "Location is required";
    }


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);
      const { hash, timestamp } = await generateHashText(userNumber, "LOGIN");

      const postData = {
        mobile: userNumber,
        orgName: userCompany,
        location: userLocation,
        email: userEmail,
        token: hash,
        timestamp: timestamp,
      };

      const response = await axios.post(
        `${appConstants.base_url}v1/adsales/request-otp`,
        postData,
        {
          headers: {
            chain: theme === "inoxTheme" ? "INOX" : "PVR",
            city: localStorage.getItem("city"),
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("API Response-----", response.data);

      if (
        response.data?.code === 10001 &&
        response.data?.result === "success"
      ) {
        const leadId = response.data?.output?.leadId || 0;
        // swal("Success", "OTP sent successfully!", "success");
        localStorage.setItem("leadId", leadId);
        setShowOtpPopup(true);
      } else {
        // swal("Error", response.data?.msg || "Something went wrong", "error");
        setErrorMsg(response.data); // ✅ store error response here
        setShowErrorAlert(true);
      }
    } catch (error) {
      console.error(error);
      // swal("Error", "Failed to request OTP. Try again later.", "error");
      setErrorMsg(response.data.msg); // ✅ store error response here
      setShowErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify OTP
  const handleVerifyOtp = async () => {
    try {
      if (!otp || otp.length < 6) {
        swal("Error", "Please enter a valid 6-digit OTP", "error");
        return;
      }

      setLoading(true);
      const leadId = localStorage.getItem("leadId");

      const verifyData = {
        otp: otp,
        leadId: leadId,
      };

      const response = await axios.post(
        `${appConstants.base_url}v1/adsales/verify-otp`,
        verifyData,
        {
          headers: {
            chain: theme === "inoxTheme" ? "INOX" : "PVR",
            city: localStorage.getItem("city"),
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Verify OTP Response::::::", response.data);

      if (
        response.data?.code === 10001 &&
        response.data?.result === "success"
      ) {
        navigate("/ads-campaigns");
        setShowOtpPopup(false);
        onClose();
        localStorage.setItem("calenderurl", response.data?.output?.calenderurl);
        localStorage.setItem("ratecardurl", response.data?.output?.ratecardurl);
        localStorage.setItem(
          "onfscreenTnc",
          response.data?.output?.onfscreenTnc
        );
        localStorage.setItem(
          "offscreenTnc",
          response.data?.output?.offscreenTnc
        );
      }
      // 🔴 Special Case: 12002 → show error dialog
      else if (response.data?.code === 12002) {
        setErrorMsg(response.data); // ✅ store error response here
        setShowErrorAlert(true);
      } else {
        setErrorMsg(response.data); // ✅ catch other errors too
        setShowErrorAlert(true);
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to verify OTP. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseBtn = () => {
    setUserNumber("");
    setUserCompany("");
    setErrors({});
    setOtp("");
    setShowOtpPopup(false);
    onClose();
  };

  return (
    <div className="login-popup-overlay">
      {!showOtpPopup ? (
        <div className="organisation-box">
          <div className="cross-icon mx-2" style={{ marginRight: "-14px" }}>
            <span onClick={handleCloseBtn}>
              <i className="pi pi-times"></i>
            </span>
          </div>

          <h5>Verify Phone Number & Organisation</h5>
          <p>
            Please enter the name of the organization for <br />
            which you’d like to run the Ad.
          </p>

          {/* Phone Number */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Phone Number"
                style={{ height: "50px" }}
                value={userNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setUserNumber(value);
                  }
                }}
              />
              <label htmlFor="Phone Number">Phone</label>
            </span>
            {errors.userNumber && (
              <small style={{ color: "red" }}>{errors.userNumber}</small>
            )}
          </div>

          {/* Organisation */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Organisation Name"
                style={{ height: "50px" }}
                value={userCompany}
                onChange={(e) => setUserCompany(e.target.value)}
              />
              <label htmlFor="Organisation Name">Organisation Name</label>
            </span>
            {errors.userCompany && (
              <small style={{ color: "red" }}>{errors.userCompany}</small>
            )}
          </div>

          {/* Email */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Email-Id"
                style={{ height: "50px" }}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
              />
              <label htmlFor="Email">Email</label>
            </span>
            {errors.userEmail && (
              <small style={{ color: "red" }}>{errors.userEmail}</small>
            )}
          </div>

          {/* Organisation */}
          <div className="mobile">
            <span className="p-float-label">
              <InputText
                id="Location"
                style={{ height: "50px" }}
                value={userLocation}
                onChange={(e) => setUserLocation(e.target.value)}
              />
              <label htmlFor="Location">Location</label>
            </span>
            {errors.userLocation && (
              <small style={{ color: "red" }}>{errors.userLocation}</small>
            )}
          </div>

          {/* Proceed */}
          <ProceedButton className="btn-proceeds" onClick={handleLogin}>
            Proceed{" "}
            {loading && (
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "1.2em" }}
              ></i>
            )}
          </ProceedButton>
        </div>
      ) : (
        // 🔑 OTP Screen
        <div className="email-otp-modal-overlay">
          <div className="email-otp-modal">
            <div className="cross-icon mx-2">
              <span onClick={handleCloseBtn}>
                <i className="pi pi-times"></i>
              </span>
            </div>

            <div className="cinema-house mobile-login-M Register-modal-desk register-track">
              <img
                src={cinemaHouse}
                alt=""
                className="img-fluid register-otp desktop-login-icon"
              />
              {spalshData && (
                <img
                  src={spalshData?.logo || (theme === "inoxTheme" ? inoxM : pvrM)}
                  alt=""
                  className="img-fluid mobile-login-icon"
                />
              )}

              <h1 className="desktop-view-login-head">Verify OTP</h1>
              <h1 className="Mobile-view-login-head">
                Verify
                <br /> OTP Code
              </h1>

              {/* ✅ Show entered phone number with Edit option */}
              <div className="otp-phone-info" style={{ marginBottom: "15px" }}>
                <p style={{ fontWeight: "bold" }}>
                  Sent to: +91 {userNumber}{" "}
                  <button
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "#000",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginLeft: "10px",
                      fontSize: "14px",

                    }}
                    onClick={() => { setShowOtpPopup(false); setOtp("") }} // go back to phone screen
                  >
                    Edit
                  </button>
                </p>
              </div>

              <p className="otp-content desktop-view-login-content">
                We've sent a code to your mobile number
              </p>
              <p className="Mobile-view-login-content">
                We've sent a code to your mobile number
              </p>

              {/* OTP Input */}
              <div className="otp-feild">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  inputType="tel"
                  numInputs={6}
                  inputStyle={{ width: "60px" }}
                  className="otp-box"
                  isInputNum={true}
                  shouldAutoFocus={true}
                  renderInput={(props, index) => (
                    <input {...props} className="otpfeild" />
                  )}
                />
              </div>
              <div className="otp-phone-info" style={{ marginBottom: "15px" }}>
                <p style={{ fontWeight: "bold" }}>
                  {/* Sent to: +91 {userNumber}{" "} */}
                  <button
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "#000",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginLeft: "10px",
                      fontSize: "14px",

                    }}
                    onClick={() => handleLogin()} // go back to phone screen
                  >
                    Re-Send OTP
                  </button>
                </p>
              </div>

              {/* Verify OTP Button */}
              <ProceedButton className="btn-proceeds" onClick={handleVerifyOtp}>
                Verify OTP{" "}
                {loading && (
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "1.2em" }}
                  ></i>
                )}
              </ProceedButton>

              <div className="resend-otp"></div>
            </div>
          </div>
        </div>
      )}
      <ConfirmMessageDialog
        icon={"error"}
        visible={showErrorAlert}
        className="fail-msg-show"
        onHide={() => setShowErrorAlert(false)}
        onConfirm={() => setShowErrorAlert(false)}
        title={errorMsg?.result} // 🔄 changed from successMsg
        message={errorMsg?.msg} // ✅ now works
        showConfirmButton={true}
        timer={2000}
        showCloseIcon={false}
      />
    </div>
  );
};

const MoreDropdown = () => {
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const [spalshData, setSpalshData] = useState(null);
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  useEffect(() => {
    profileRequest();
  }, [localStorage.getItem("city")]);
  const hitGa = (event) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: event,
    });
  };
  const hitMoreGa = (click_text) => {
    let dataLayer = window["dataLayer"] || [];
    dataLayer.push({
      event: "top_navi_more_click",
      click_text: click_text,
    });
  };
  const profileRequest = async () => {
    getSplashData()
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          setSpalshData(dt.output);
        } else {
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  return (
    <>
      <LoginPopup
        isOpen={isLoginPopupOpen}
        onClose={() => setIsLoginPopupOpen(false)}
      />
      <div className="more">
        <img src={menubar} alt="" className="img-fluid" />
        <span className="mx-2 more-center">More</span>
        <img src={custoArrowB} alt="" className="more-side" />
        <div className="more-content rounded">
          <ul>
            {/* <li
              className="more-item"
              onClick={() => {
                const currentPath = window.location.pathname;
                hitMoreGa("Gift Cards");
                if (currentPath === "/gift-cards") {
                  window.location.href = "/gift-cards";
                } else {
                  navigate("/gift-cards"); // Use your navigation function here
                }
              }}
            >
              <img src={giftCardIcon} alt="" className="mx-2" />
              Gift Card
            </li> */}
            <li
              className="more-item"
              onClick={() => {
                hitGa("top_navi_offers");
                window.open("https://smartodr.in/login", "_blank").focus();
              }}
            >
              <div className="nav-icons">
                {theme === "inoxTheme" ? (
                  <img src={OdrBlack} alt="" className="img-fluid mx-2" />
                ) : (
                  <img src={OdrBlack} alt="" className="img-fluid mx-2" />
                )}
              </div>
              <div
                className="useful-link"
                onClick={() => {
                  hitGa("ODR_PORTAL");
                }}
              >
                ODR Portal
              </div>
            </li>

            <li
              className="more-item"
              onClick={() => {
                const currentPath = window.location.pathname;
                hitMoreGa("Bulk Gift Cards");
                if (currentPath === "/bulk-gift-cards") {
                  window.location.href = "/bulk-gift-cards";
                } else {
                  navigate("/bulk-gift-cards"); // Use your navigation function here
                }
              }}
            >
              <img src={giftCardIcon} alt="" className="mx-2" />
              Bulk Gift Card
            </li>
            {/* {String(spalshData?.adsales).toLowerCase() === "true" && (
              <li
                className="more-item"
                onClick={() => {
                  hitMoreGa("Ads Campaigns");
                  setIsLoginPopupOpen(true);
                }}
              >
                <img src={Honk} alt="" className="mx-2" />
                Advertise with us
              </li>
            )} */}
            {/* <li
                            className='more-item'
                            onClick={() => {  hitMoreGa("Kotak Privilege+");
                            navigate('/#')}}
                        >
                            <img src={kotak} alt="" className="mx-2" />
                            Kotak Privilege+
                        </li> */}
            {/* <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Advetise");
                const currentPath = window.location.pathname;
                if (currentPath === "/advertise") {
                  window.location.href = "/advertise";
                } else {
                  navigate("/advertise"); // Use your navigation function here
                }
              }}
            >
              <img src={advertiseIcon} alt="" className="mx-2" />
              Advertise
            </li>

            <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Ads Campaigns");
                // Instead of navigating, open the login popup
                setIsLoginPopupOpen(true);
              }}
            >
              <img src={Honk} alt="" className="mx-2" />
              Ad Sales
            </li>
            {/* <li
                            className='more-item'
                            onClick={() => {
                                hitGa('vpristine');
                                hitMoreGa('vpristine');
                                window.open(
                                    theme === "inoxTheme"
                                        ? "https://www.pvrcinemas.com/pvrstatic/PVR-VpristineB2C/"
                                        : "https://www.pvrcinemas.com/pvrstatic/PVR-VpristineB2C/",
                                    "_blank"
                                );
                             
                          
                            }}
                        >
                            <img src={pristineIcon} alt="" className="mx-2" />
                            V Pristine
                        </li> */}
            {/* <li
                            className='more-item'
                            onClick={() => {
                                                                hitGa('pvr_cares');

                                window.open(
                                    theme === "inoxTheme"
                                      ? "https://www.pvrcinemas.com/pvrstatic/pvr-care/"
                                      : "https://www.pvrcinemas.com/pvrstatic/pvr-care/",
                                    "_blank"
                                  );
                            }}
                        >
                            <img src={pvrcareIcon   } alt="" className="mx-2" />
                            PVR Cares
                        </li> */}
            {/* <li
              className="more-item"
              onClick={() => {
                hitMoreGa("Merchandise");

                window.open(
                  theme === "inoxTheme"
                    ? "https://inox.macmerise.com/"
                    : "https://pvr.macmerise.com/?user_agent=pvr/",
                  "_blank"
                );
              }}
            >
              <img src={merchandiseIcon} alt="" className="mx-2" />
              Merchandise
            </li> */}
            {spalshData?.pvrlive ? (
              <li
                className="more-item"
                onClick={() => {
                  hitGa("live_movies");
                  const currentPath = window.location.pathname;
                  if (currentPath === "/live-movies") {
                    window.location.href = "/live-movies";
                  } else {
                    navigate("/live-movies"); // Use your navigation function here
                  }
                }}
              >
                <img src={filmFestival} alt="" className="mx-2" />
                {spalshData?.pvrlive}
              </li>
            ) : (
              ""
            )}
            {spalshData?.screenit_web ==="true" && (
              <li
                className="more-item"
                onClick={() => {
                  hitGa("screenit_click");
                  const currentPath = window.location.pathname;
                  if (currentPath === "/screenit") {
                    window.location.href = "/screenit";
                  } else {
                    navigate("/screenit");
                  }
                }}
              >
                <img src={Screenit_icon} alt="" className="mx-2" />
                ScreenIT
              </li>
            )}
            {/* <li
              className='more-item'
              onClick={() => {               
                const currentPath = window.location.pathname;
                if (currentPath === "/promote-earn  ") {
                  window.location.href = "/promote-earn";
                } else {
                  navigate("/promote-earn");
                }
              }}
            >
              <img src={promoteEarn} alt="" className="mx-2" />
              Promote & Earn
            </li>  */}
            <li>
              <div className="menu-divider"></div>
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                // hitMoreGa('Feedback');

                const currentPath = window.location.pathname;
                if (currentPath === "/feedback") {
                  window.location.href = "/feedback";
                } else {
                  // hitGa('feedback')
                  hitMoreGa("Feedback");
                  hitGa("feedback");
                  navigate("/feedback"); // Use your navigation function here
                }
              }}
            >
              Customer Experience
            </li>

            {String(spalshData?.upi_mandate).toLowerCase() === "true" && (
              <li
                className="more-item mx-2"
                onClick={() => {
                  hitMoreGa("UPI Mandate");
                  window.open("https://web.pvrinox.com/mandate", "_blank");
                  // Instead of navigating, open the login popup
                }}
              >
                UPI Reserve Pay
              </li>
            )}

            {theme === "inoxTheme" ? (
              ""
            ) : (
              <li
                className="more-item mx-2"
                onClick={() => {
                  hitMoreGa("Privilege Plus");

                  const currentPath = window.location.pathname;
                  if (currentPath === "/kotak-pp-plus") {
                    window.location.href = "/kotak-pp-plus";
                  } else {
                    navigate("/kotak-pp-plus"); // Use your navigation function here
                  }
                }}
              >
                Privilege Plus
              </li>
            )}

            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Kotak Cards");
                window.open("https://web.pvrinox.com/kotak-cards", "_blank");
              }}              >
              PVR INOX Kotak Credit Card
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("About us");
                const currentPath = window.location.pathname;
                if (currentPath === "/about-us") {
                  window.location.href = "/about-us";
                } else {
                  navigate("/about-us"); // Use your navigation function here
                }
              }}
            >
              About us
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Experiences");

                const currentPath = window.location.pathname;
                if (
                  currentPath ===
                  "/experience/" + localStorage.getItem("city")
                ) {
                  window.location.href =
                    "/experience/" + localStorage.getItem("city");
                } else {
                  navigate("/experience/" + localStorage.getItem("city")); // Use your navigation function here
                }
              }}
            >
              Experiences
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("coroporate-booking");
                const currentPath = window.location.pathname;
                if (currentPath === "/bulkbooking/coroporate-booking") {
                  window.location.href = "/bulkbooking/coroporate-booking";
                } else {
                  navigate("/bulkbooking/coroporate-booking"); // Use your navigation function here
                }
              }}
            >
              Bulk & Corporate Bookings
            </li>
            {/* <li
              className="more-item mx-2"
              onClick={() => {
                const currentPath = window.location.pathname;
                if (currentPath === "/oscar") {
                  window.location.href = "/oscar";
                } else {
                  navigate("/oscar");
                }
              }}
            >
              Oscar
            </li> */}
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("FAQ");

                const currentPath = window.location.pathname;
                if (currentPath === "/faq") {
                  window.location.href = "/faq";
                } else {
                  navigate("/faq"); // Use your navigation function here
                }
              }}
            >
              FAQs
            </li>
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Career");

                const currentPath = window.location.pathname;
                if (currentPath === "/careers-us") {
                  window.location.href = "/careers-us";
                } else {
                  hitGa("career");

                  navigate("/careers-us"); // Use your navigation function here
                }
              }}
            >
              Career
            </li>

            {/* <li
                            className='more-item mx-2'
                            onClick={() => navigate('/advertise')}
                        >
                           Advertise
                        </li> */}
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("News");

                const currentPath = window.location.pathname;
                if (currentPath === "/news") {
                  window.location.href = "/news";
                } else {
                  navigate("/news"); // Use your navigation function here
                }
              }}
            >
              News
            </li>
            {/* <li
                            className='more-item mx-2'
                            onClick={() => {
                                hitMoreGa('Beyond Movies');

                                const currentPath = window.location.pathname;
                                if (currentPath === '/beyond-movies') {
                                    window.location.href = '/beyond-movies';
                                } else {
                                    navigate('/beyond-movies'); // Use your navigation function here
                                }
                            }}
                        >
                           Beyond Movies
                        </li> */}
            {/* <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("Investors Section");

                const currentPath = window.location.pathname;
                if (currentPath === "/investors-section") {
                  window.location.href = "/investors-section";
                } else {
                  hitGa("investors-section");
                  navigate("/investors-section"); // Use your navigation function here
                }
              }}
            >
              Investors Section
            </li> */}
            <li
              className="more-item mx-2"
              onClick={() => {
                hitMoreGa("NVSP");

                window.open(
                  theme === "inoxTheme"
                    ? "https://voters.eci.gov.in/"
                    : "https://voters.eci.gov.in/",
                  "_blank"
                );
              }}
            >
              NVSP
            </li>
            <li
              className=""
              onClick={() => {
                hitMoreGa("NEST");

                window.open("https://pvrnest.godaddysites.com/home", "_blank");
              }}
            >
              NEST
            </li>
            {/* <li
                            className='more-item mx-2'
                            onClick={() => {
                                hitMoreGa('Birthday Request');

                                const currentPath = window.location.pathname;
                                if (currentPath === '/birthday-request') {
                                    window.location.href = '/birthday-request';
                                } else {
                                    navigate('/birthday-request'); // Use your navigation function here
                                }
                            }}
                        >
                           Birthday Request
                        </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default MoreDropdown;
